import { render } from "./ChangeReviewDialog.vue?vue&type=template&id=41d7a376&scoped=true&ts=true"
import script from "./ChangeReviewDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeReviewDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeReviewDialog.vue?vue&type=style&index=0&id=41d7a376&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d7a376"],['__file',"resources/js/views/objectives-report/features/change-review/ChangeReviewDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41d7a376"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41d7a376', __exports__)) {
    console.log('reload')
    api.reload('41d7a376', __exports__)
  }
  
  module.hot.accept("./ChangeReviewDialog.vue?vue&type=template&id=41d7a376&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('41d7a376', render)
  })

}


export default __exports__